export function checkUrl() {
    return window.location.origin === "http://www.yourstutors.com" ? "/tutorsapi"
          : window.location.origin === "http://yourstutors.com" ? "/tutorsapi"
          : window.location.origin === "https://yourstutors.com" ? "/tutorsapi"
          : window.location.origin ==="https://www.yourstutors.com" ? "/tutorsapi"
          : window.location.origin === "http://134.209.152.216:8088" ? "http://134.209.152.216:8088"
          : window.location.origin ==="http://localhost:4200" ? "http://localhost:8088"
          : window.location.origin ==="http://localhost:8088" ? "http://localhost:8088"
          :"Invalid call";
}

  